import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHotelSecond = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconHotelSecond",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M11.76 9.41v-4.7H10.6v1.76H9.4V4.71H8.24v4.7H9.4V7.65h1.18V9.4z"
  }), _jsx("path", {
    d: "M20 6.47h-4.12V0H4.12v6.47H0V10h1.18v10h17.64V10H20zM1.18 7.65h2.94v1.17H1.18zm2.94 11.17H2.35V10h1.77zm4.12 0v-4.7H10v4.7zm1.76 0v-4.7h1.76v4.7zm4.7 0h-1.76v-5.88H7.06v5.88H5.29V1.18h9.42zm2.95 0h-1.77V10h1.77zm1.17-10h-2.94V7.65h2.94z"
  })]
}));